import { render, staticRenderFns } from "./goodsSkuInfo.vue?vue&type=template&id=0228aaf8&scoped=true&"
import script from "./goodsSkuInfo.vue?vue&type=script&lang=js&"
export * from "./goodsSkuInfo.vue?vue&type=script&lang=js&"
import style0 from "./goodsSkuInfo.vue?vue&type=style&index=0&id=0228aaf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0228aaf8",
  null
  
)

export default component.exports